<template>
  <div class="page" :class="isMobile?'':'PC'" v-wechat-title="$route.meta.title">
    <!--地图-->
    <div class="map-box">
      <div class="amap" id="container"></div>
      <!--<el-amap class="amap" vid="container" id="container" resizeEnable="true"></el-amap>-->

    </div>

    <!--小图标-->

    <div class="map-icons">
      <div class="map-icon">
        <div class="border-box" @click="clickFun1('view')" v-if="!formGuide && !vrbagid" >
          <img src="../../assets/icon_44.png" alt="">
          <p>解说</p>
        </div>
        <div class="border-box" @click="getVrDesc(vrbagid),appendMarker(spotlist,'spot'),moveCenter(shop.lng, shop.lat);" v-if="vrbagid" >
          <img src="../../assets/icon_44.png" alt="">
          <p>VR解说</p>
        </div>
        <div class="border-box" @click="searWC('wc')">
          <img src="../../assets/icon_40.png" alt="">
          <p>厕所</p>
        </div>
        <div class="border-box" @click="searWC('exit')">
          <img src="../../assets/icon_43_2.png" alt="">
          <p style="font-size: .18rem;letter-spacing: 0;margin: .05rem -.11rem 0;">出入口</p>
        </div>
        <a class="border-box" href="tel:18728497523">
          <img src="../../assets/icon_21.png" alt="">
          <p>帮助</p>
        </a>
      </div>

      <img class="mygps" src="../../assets/icon_25.png" alt="" @click="getAndPantoLocation()">
    </div>


    <div class="spot" :class="showList?'active':''">
      <!--语音播放操作栏-->
      <div class="guide border-box" :class="playshow?'active':''" v-if="currIndex>=0&&toastshow==0&&!vrbagid">
        <div class="guide-box box" v-if="playshow">
          <div class="guide-img" @click.stop="navList=3,scollToDom('voice-list-p'+voicelist[index1].spotid,'VoiceScoll')"><img class="img" :src="currGuide.guideheadimg2" alt=""></div>
          <div class="guide-voice flex">
            <p class="guide-tit hide">当前播放：{{currGuide.guidename2}} - {{voicelist[index1].spotname}}</p>
            <div class="guide-btn">
              <img class="fl" src="../../assets/icon_11.png" alt="" @click.stop="prevPlay()">
              <img class="fl play" :src="isplay==0?require('../../assets/icon_12.png'):require('../../assets/icon_12_curr.png')" alt="" @click.stop="playVideoClick(index1)">
              <img class="fl" src="../../assets/icon_13.png" alt="" @click.stop="nextPlay()">
            </div>
          </div>
        </div>
        <div class="guide-icon" @click="playshow=!playshow"></div>
      </div>


      <div class="spot-nav">
        <div class="spot-li box"  v-if="currSpot&&currSpot.id">
          <div class="spot-li-img"><img class="img" :src="currSpot.logo" alt=""></div>
          <div class="spot-li-info flex">
            <h3 class="hide">{{currSpot.name}}</h3>
            <p class="hide" v-if="isMobile">{{getDistance(currSpot.lat,currSpot.lng,position.lat,position.lng)}}</p>
            <div class="but">
              <div class="spot-nav-list" @click.stop="toDetail(currSpot.id)" style="display: none">
                <img class="icon" src="../../assets/icon_37_curr.png" alt="">
                <p class="txt">详情</p>
              </div>
              <div class="spot-nav-list" @click.stop="openMap('spot',currSpot)">
                <img class="icon" src="../../assets/icon_23.png" alt="">
                <p class="txt">导航</p>
              </div>
            </div>
          </div>
        </div>
        <div class="spot-li box"  v-else-if="shop&&shop.logo">
          <div class="spot-li-img"><img class="img" :src="shop.logo" alt=""></div>
          <div class="spot-li-info flex">
            <h3 class="hide">{{shop.name}}</h3>
            <p class="hide" v-if="isMobile">{{getDistance(shop.lat,shop.lng,position.lat,position.lng)}}</p>
            <div class="but">
              <div class="spot-nav-list" @click.stop="toDetail('')" style="display: none">
                <img class="icon" src="../../assets/icon_37_curr.png" alt="">
                <p class="txt">详情</p>
              </div>
              <div class="spot-nav-list" @click.stop="openMap('spot',shop)">
                <img class="icon" src="../../assets/icon_23.png" alt="">
                <p class="txt">导航</p>
              </div>
            </div>
          </div>
        </div>
        <p class="spot-nav-arr" @click="showList=!showList"></p>
      </div>

      <div class="spot-cont" id="spotCont">
        <!--导游列表-->
        <div class="spot-guide border-box" v-if="navList==1">
          <div class="spot-tab box" v-if="tablist.length>2">
            <p class="flex" :class="cid==item.id?'curr':''" v-for="(item,index) in tablist" :key="index" @click="tablistClick(item.id)"><span>{{item.name}}</span></p>
          </div>
          <div class="spot-scoll border-box">
            <div class="scoll-list clearfix">
              <div class="list-li box" v-for="(item,index) in guidelist" :key="index" @click="openGuide(item.id)">
                <div class="list-li-img">
                  <img class="img" v-lazy="item.headimg" :key="item.id" alt="">
                  <span class="gif" v-if="isplay==1&&currGuide.id==item.id"><img src="../../assets/icon_listen01.gif" alt=""></span>
                </div>
                <div class="flex list-li-info">
                  <p class="tit hide">{{item.guide}} <span class="tag" v-if="item.guidetag">{{item.guidetag}}</span> </p>
                  <p class="name hide">{{item.NAME}} <span class="tag" v-if="item.label">{{item.label}}</span></p>
                  <div class="clearfix">
                    <p class="label" v-if="item.listens>0">
                      <img src="../../assets/icon-label-listen.png" alt="">
                      <span>{{item.listens|initNumber}}人收听</span>
                    </p>
                    <p class="label" v-if="(item.dsnum>0&&item.buynum<=0)||(item.dsnum>0&&item.price<=0)">
                      <img src="../../assets/icon-label-buy.png" alt="">
                      <span>{{item.dsnum|initNumber}}人打赏</span>
                    </p>
                    <p class="label" v-else-if="item.buynum>0 && noBuys.indexOf(shopid)<=-1">
                      <img src="../../assets/icon-label-buy.png" alt="">
                      <span>{{item.buynum|initNumber}}人购买</span>
                    </p>
                  </div>
                  <div class="bottom">
                    <p class="pri" v-if="item.price>0">{{item.price}}元 <span>(包含{{item.spotnum}}个讲解点)</span></p>
                    <p class="pri" v-else><span>(包含{{item.spotnum}}个讲解点)</span></p>

                    <span class="button" @click.stop="openGuide(item.id)" v-if="item.buy>0 || item.price==0">收听</span>
                    <span class="button" @click.stop="buyVideo(item)" v-else>购买</span>
                  </div>
                </div>

              </div>
              <p class="load-tip" v-if="guidelist.length<=0">{{loadText}}</p>
            </div>
          </div>
        </div>
        <!--厕所列表-->
        <div class="spot-guide border-box" v-if="navList==2">
          <div class="navtab-scoll border-box" id="WCScoll">
            <div class="spot-li" :id="'spot-liWC'+item.id" v-for="(item,index) in wclist" :key="index" @click="openMap('wc',item)">
              <div class="spot-li-info border-box" :class="currWC&&currWC.id==item.id?'curr':''" style="width:100%;">
                <h3 class="hide">{{item.name}}</h3>
                <p class="hide">{{item.address}}</p>
                <div class="but">
                  <span class="button" @click.stop="openMap('wc',item)">导航</span>
                </div>
              </div>
            </div>
            <p class="load-tip" v-if="noWc">暂无数据</p>
          </div>
        </div>
        <!--语音列表-->
        <div class="spot-guide border-box" v-if="navList==3 && !vrbagid">
          <div class="navtab-scoll border-box" id="VoiceScoll">
            <div class="voice-list">
              <p class="voice-list-p clearfix" :id="'voice-list-p'+item.spotid" v-for="(item,index) in voicelist" :key="index" :class="currIndex==index?'curr':''" @click="playVideoClick(index)">
                <img class="fl" src="../../assets/icon_16.png" alt="" v-if="currIndex==index">
                <span v-else>{{index+1}}.</span>
                {{item.spotname}}
                <font v-if="index<2&&buy!=true">(免费收听）</font>
                <span class="fr" v-if="currIndex==index&&isplay">{{currTime|initTime}}</span>
                <img class="fr" :src="(index<2||buy==true)?require('../../assets/icon_15.png'):require('../../assets/icon_14.png')" alt="" v-else>
              </p>
            </div>
          </div>
        </div>
        <!--VR列表-->
        <div class="spot-guide border-box" v-if="navList==3 && vrbagid">
          <div class="navtab-scoll border-box" id="VoiceScoll">
            <div class="voice-list clearfix" style="padding: 0 0 .8rem;">

              <div class="vr-list border-box clearfix"  v-for="(item,index) in voice" :key="index">
                <p class="vr-list-tit"><img src="../../assets/icon_gps1.png" /> {{item.pspotname}}</p>

                <div class="vr-list-p" :id="'vr-list-p'+ite.spotid" v-for="(ite,ind) in item.list" :key="ind" :class="currIndex==ite.number?'curr':''" @click="openVR(ite.number)">
                  <p class="p1 border-box"><img class="img"  v-lazy="ite.logo" alt=""></p>
                  <p class="p2 hide">{{ite.spotname}}</p>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>

    <!--全景视频弹窗-->
    <div class="video-alert" :class="windowResize==1?'windowW':''" v-show="videoAlert==1">
      <p class="video-tip" @click="closeVR()">关闭<img src="../../assets/h5_logo.png" alt=""></p>

      <div class="vr-point" :style="item.vrPointStyle" v-for="(item,index) in maolist" :key="index" v-if="item.isshow==1 && isBegin" @click="vrContShowFun(item)">
        <p class="vr-txt" :class="'colr'+item.color" v-if="item.title">{{item.title}}</p>
        <div class="vr-dot" :class="'colr'+item.color"></div>
      </div>

      <div id="panoDesk"></div>
      <div class="toolTxt" v-if="bagList && bagList.length>0 && bagList[switchScneNumber] && bagList[switchScneNumber].txtarr && txtcurr">{{txtcurr}}</div>
      <div class="toolBar" id="toolBar">
        <div class="toolBox" ref="toolBox"  :style="'width: '+ toolBoxW +'px;'">
          <div class="toolBtn" :id="'toolBtn'+item.id" :class="switchScneNumber==item.number?'curr':''" v-for="(item,index) in bagList" :key="index" @click="switchScne(item.number)">
            <img  v-lazy="item.logo" alt="">
            <p class="video-see" v-if="item.hotLevel==1">必看</p>
            <div class="toolBtn-tit">
              <p class="p1 hide">{{item.spotname}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="alert-box alert-info" v-if="vrContShow" id="vrCont">
      <div class="mask" @click="vrContShow=0"></div>
      <div class="alert-con border-box">
        <img src="../../assets/vr-close.png" alt="" class="close" @click="vrContShow=0">
        <div class="tit tc border-box hide">{{vrContShow.title?vrContShow.title:bagList[switchScneNumber].spotname}}</div>
        <div class="info-scroll border-box">
          <div class="txt" v-html="vrContShow.cont" v-if="vrContShow.cont" ref="content" @click="imageEnlargement"></div>
          <div class="txt" v-html="bagList[switchScneNumber].sub" v-else></div>

          <img v-for="(ite,ind) in (bagList[switchScneNumber].allimg).split(',')"  @click="seeImg(ind,(bagList[switchScneNumber].allimg).split(','))" v-lazy="ite"  :key="ite" v-if="bagList[switchScneNumber].allimg && !vrContShow.cont"/>
        </div>
      </div>
    </div>

    <audio id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>

  </div>

</template>

<script>
  import Vue from 'vue';

  window._AMapSecurityConfig = {
    securityJsCode:'89eb2b00868f9e6ac15de6c0e7460d32'
  };

  import {mapIndex, mapShop,mapBagTab,mapBagList,mapSpot, mapBagDetail,mapSearch,mapPolyline, getBagComment, getZan,getVideoPlay,getVrmaoList,getVrmaoUpload } from "@/service/getData";
  import {wxGetPosition,wxShareme,wxOpenMapLocation,playVideo,playDragSlide,wxImgPreview,creatOrder,TimeVideo,getSrtTxt,playRecord} from '@/utils/wechat'

  import {setStore, getStore, removeStore, scollLoadMore,GAMPGL} from '@/config/mUtils'

  import AlertComment from '../../components/AlertComment'
  import AlertPoster from '../../components/AlertPoster'
  import P400 from '../../components/P400'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  Vue.use(D)

  var Map = null,watchid=null;  //地图对象
  var fromPath,fullPath;
  var MyPlayerObj = null,txtTimer = null,MyPlayerStop = false;

  export default {
    data: function() {
      return {
        userInfo: {}, //用户信息
        siteid: this.$route.query.siteid || '', //站点id
        sregion: this.$route.query.sregion || '', //省站点id
        shopid: this.$route.query.shopid || '69', //景区id
        spotid: this.$route.query.spotid || '', //景点id
        bagid: this.$route.query.bagid || '', //专辑id
        formGuide: this.$route.query.formGuide || '', //从导游详情页过来

        loadText: '', //暂无数据
        shop: [], //景区详情
        spotlist: [], //景点列表
        cid: 0, //导游类型:默认购买
        guidelist: [], //导游列表
        tablist: [], //导游类型
        wclist: [], //厕所数据
        noWc: false, //查询没有厕所

        showList: true, //false不展示列表 true:展示列表
        navList: 1, //1:显示导游列表 2：显示厕所  3:解说点
        currSpot: null, //当前选中的景点
        currWC: null, //当前选中的厕所
        currMarkerData: {
          marker: "",
          className: ""
        }, // 记录当前点击的地图点标记

        myInteval: null, //实时定位计时器
        locationMarker: null, //定位点
        pointor: true, //监听设备陀螺仪转动
        inSenic: false, //判断是否在景区
        showInSenicTips: true, //是否提示在景区
        boundsLimit: null, //景区范围围栏
        rectangle: null, //景区范围矩形
        position: getStore("position") || {lat: '', lng: ''},  //手机定位经纬度信息
        markerList: [], //地图上的点标记

        currGuide: {}, //选择的导游信息
        voicelist: [], //选择的导游的语音列表
        toastshow: 0, //选中导游弹窗
        buy: false, //选中导游的专辑是否购买

        playshow: false, //是否展开播放操作栏
        currTime: 0, //当前播放音频的实时时间
        isplay: 0, //是否在播放
        currIndex: -1, //正在播放的语音下标
        index1: 0, //当前播放音频数组下标(用来记录currIndex)

        appKey: '',
        appKeyA: '',
        P400: 0, //系统维护中
        noBuys: '1598', //不显示购买量的景区shopid

        vrbagid: this.$route.query.vrbagid || '5170', //vr专辑id
        voice: [], //vr二维数组结构
        bagList: [],
        videoAlert:0,//全景视频弹窗
        videoAlertMask:1,//全景视频弹窗蒙层
        windowResize:'',//手机横竖屏设置 0:竖屏 1：横屏
        toolBoxW: 0, //底部预览图部分的宽度
        switchScneNumber: 0, //当前播放的
        preNumber: '', //上一个播放的
        txtcurr: '', //当前显示的字体
        cutTime: -1, //卡顿时的时间
        vrIconShow: true, //是否显示去听语音的图标
        vrPointStyle: {left: '-200px', top: '-200px'},
        vrContShow: 0,//热点详情弹窗
        maolist: [], //某个视频对应的热点
        isBegin: false, //是否开始播放
        isMobile: true, //默认移动端
      };
    },
    created() {

      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey": this.appKey});
      } else {
        setStore("appKey", {"appKey": ""});
      }

      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        this.isMobile = true;
        console.log('当前在手机端');

        this.userInfo = getStore("userInfo");
      } else {
        this.isMobile = false;
        console.log('当前在PC端');

        this.userInfo = {
          openid: "oUYE8xN4ZRA-u53-uR_qP7GeLJu8", //黄月
          txOpenid: "oUYE8xN4ZRA-u53-uR_qP7GeLJu8",
          headimg: "https://filewc.geeker.com.cn/jpjs/upload/headimg/20200926/aby8dj3j36da68jwjh4gj8fgmhef5cf76j13j1.jpg",
          utype: "user",
          city: "成都",
          jointime: "2018-11-06 12:51:13",
          gender: 1,
          istui: 0,
          unionId: "oINhv0zA9xZ0xGvSvmEX6I6Lx5Gw",
          uptime: "2018-11-06 14:32:57",
          name: "缺心眼子",
          id: 53891,
          state: 1
        };
        setStore("userInfo", this.userInfo)
      }

      var self = this;
      if(self.shopid){
        if(self.isMobile){
          self.$loading.show('获取定位');
          wxGetPosition(function(res){
            self.position = {lat: res.latitude, lng: res.longitude };
            setStore("position", self.position);
            self.getView();
          });
        }else {
          self.getView();
        }

        if(self.bagid){
          self.openGuide(self.bagid);
        }else if(self.vrbagid){
          self.getVrDesc(self.vrbagid)
        }else {
          self.getTablist();
        }
      }else {
        alert("当前区域暂无地图导览");

        setTimeout(function(){
          self.$router.go(-1);//返回上一页
        },2500)
      }

      this.renderResize();
      this.$nextTick(() => {
        window.addEventListener("resize", this.renderResize, false)
      });


    },
    beforeDestroy(){
      if(this.myInteval){
        clearInterval(this.myInteval);
        this.myInteval = null;
      }
      window.removeEventListener("resize", this.renderResize, false)
      if(MyPlayerObj){
        this.closeVR();
      }
      this.clearTxt();
    },
    methods: {
      //获取景区详情
      async getView(){
        let res = await mapShop({
          id: this.shopid
        });
        if (res.errcode === "00000"){
          if(this.isMobile) {
            this.$loading.hide();
          }
          var shop = res.data.shop;
          shop.lng = parseFloat(shop.lng);
          shop.lat = parseFloat(shop.lat);
          this.shop = shop;
          this.spotlist = res.data.spots;

          this.$route.meta.title = this.shop.name || '地图导览';

          let title = this.userInfo.name + '@你：';
          let desc = '历史会说话！金牌解说与您共享历史故事~';
          let link = '';
          if(this.bagid){
            link = '/map-vr?bagid='+this.bagid+'&shopid='+this.shopid;
          }else if(this.vrbagid){
            link = '/map-vr?vrbagid='+this.vrbagid+'&shopid='+this.shopid;
          }
          wxShareme(title, desc, shop.logo, link);

          var self = this;
          GAMPGL('404573c508c5457fdc8040930e2efe6e').then(function (AMap) {
            self.initMap();
          });
        }
      },

      //获取景区或景点专辑列表
      async getGuidelist(){
        let res = await mapBagList({
          openid: this.userInfo.openid,
          shopid: this.shopid,
          spotid: this.spotid || '',
          cid: this.cid || ''
        });

        this.loadText = '';
        this.guidelist = [];

        if (res.errcode === "00000" && res.data && res.data.length > 0){
          this.$loading.hide();
          this.guidelist = res.data;

        }else {
          this.$loading.hide();
          this.loadText = '暂无数据'
        }
      },

      //请求导游分类
      async getTablist(){
        let res = await mapBagTab({
          openid:  this.userInfo.openid,
          shopid: this.shopid,
          spotid: this.spotid || ''
        });
        if (res.errcode === "00000"){
          this.tablist = res.data;
          if(res.data && res.data.length>0){
            this.tablistClick(res.data[0].id);
          }

        }
      },

      //导游分类列表切换
      tablistClick: function(cid){
        this.$loading.show('数据加载中');
        this.cid = cid || '0';
        this.getGuidelist();
      },

      //进入导游详情
      openGuide: function (id){
        if(this.currGuide && this.currGuide.id == id){
          this.navList = 3;
          this.scollToDom('voice-list-p'+this.spotid,'VoiceScoll')
        }else {
          if(this.global.videoTimer && this.global.currBag&&this.global.currBag.id != id){
            clearInterval(this.global.videoTimer);
            this.currIndex = -1;
            this.global.Audio1.pause();
            this.isplay = 0;
          }

          this.$loading.show('数据加载中');

          this.currGuide = {};
          this.voicelist = [];
          this.getVideoinfo(id);
        }
      },

      //请求导游专辑详情
      async getVideoinfo(id){
        let res = await mapBagDetail({
          openid: this.userInfo.openid,
          id: id
        });
        if (res.errcode === "00000"){
          this.$loading.hide();
          this.buy = (res.data.bag.isbuy == true || res.data.bag.price <= 0) ? true : false;
          this.currGuide = res.data.bag;
          this.currGuide.shopid = this.shopid;
          this.voicelist = res.data.voiceList;
          this.navList = 3;

          let self = this;
          if(self.buy){
            self.scollToDom('voice-list-p'+self.spotid,'VoiceScoll')
          }

          self.$nextTick(function(){
            setTimeout(function(){
              if(self.global.currUrl == ""){
                self.global.Audio1 = document.getElementById('Audio1');
                self.global.Audio1.src = self.voicelist[self.index1].url;
                self.global.Audio1.preload = "auto";

                self.global.set_currBag(self.currGuide)
                self.global.set_currUrl(self.voicelist[self.index1].url)
              }else if(self.global.currBag&&self.global.currBag.id == id&&self.global.currUrl != ""){
                self.index1 = self.getIndex(self.voicelist,self.global.currVoice.spotid);
                self.currIndex = self.index1;
                self.isplay = self.global.playing ? 1 : 0;

                self.currTime = self.global.Audio1.currentTime;
                self.currSlider = (self.global.Audio1.currentTime / self.voicelist[self.index1].totaltime) * self.global.sliderWidth + "px";

                if(self.global.playing){
                  setTimeout(function(){
                    TimeVideo(self,self.voicelist[self.index1].totaltime);
                  },800)
                }

              }

            },800)
          })

        }else {
          this.$loading.hide();
        }
      },

      //拿到数组中指定spotid的下标
      getIndex(arr,spotid,type){
        let result;
        if(type == 2){
          if(arr.find(function(x) {return x.id == spotid;}) != undefined) {
            arr.find(function(x,i) {
              if(x.id == spotid){
                result =  i;
              }
            });
            return result;
          }else {
            return 0;
          }
        }else {
          if(arr.find(function(x) {return x.spotid == spotid;}) != undefined) {
            arr.find(function(x,i) {
              if(x.spotid == spotid){
                result =  i;
              }
            });
            return result;
          }else {
            if(type==1){
              return -1;
            }else {
              return 0;
            }
          }
        }
      },

      //初始化地图
      initMap: function() {
        var self = this;
        var zoom = self.shop.zoom || 16;
        zoom = self.isMobile?zoom:(zoom+1);
        Map = new AMap.Map("container", {
          features: ['bg', 'road'],
          showBuildingBlock: false,
          animateEnable: true,
          zoom: zoom,
          zooms: [12, 20],
          doubleClickZoom: true,
          center: [self.shop.lng, self.shop.lat]
        });

        AMap.plugin(['AMap.Geolocation', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.PolyEditor','AMap.Rectangle'],function(){//异步加载插件

          //添加地图范围 + 手绘地图
          var northEast = self.shop.northEast, southWest = self.shop.southWest;
          if(northEast && southWest) {
            var northEast1 = new AMap.LngLat(parseFloat(northEast[0]), parseFloat(northEast[1]));
            var southWest1 = new AMap.LngLat(parseFloat(southWest[0]), parseFloat(southWest[1]));

            self.boundsLimit = new AMap.Bounds(southWest1, northEast1);
            //Map.setLimitBounds(self.boundsLimit);

            // 手绘图
            if (self.shop.mapimg) {
              let imageLayer = [
                new AMap.TileLayer(),
                new AMap.ImageLayer({
                  url: self.shop.mapimg,
                  bounds: self.boundsLimit
                })
              ];
              Map.setLayers(imageLayer);

              Map.on("dblclick",function(){
                Map.zoomIn();
              });
            }

            // 创建矩形地图范围，用来判断是否在景区内
            if(self.boundsLimit){
              self.rectangle = new AMap.Rectangle({
                map: Map,
                bounds: self.boundsLimit,
                strokeOpacity: 0,
                fillOpacity:0,
                zIndex:0
              });
            }

          }
          self.appendMarker(self.spotlist,'spot');

          // 设置景区中心点为地图中心点
          if (self.shop.lng && self.shop.lat) {
            self.moveCenter(self.shop.lng, self.shop.lat);
          }

          if(self.isMobile){
            self.getPosition(1); //定位
          }


//          self.myInteval = setInterval(function(){
//            self.getPosition(); //定位
//          },3000);

          self.deviceRotate();  //监听手机转动

          Map.on("complete", function() {
            console.log("complete");


          });
        });


      },

      //移动地图中心到指定景点
      moveCenter: function (lng,lat){
         Map.setCenter([parseFloat(lng),parseFloat(lat - 0.001)]);
      },
      //手动获取定位 + 平移到当前位置
      getAndPantoLocation: function (){
//        this.$loading.show('重新获取定位');
        if(this.position.lng && this.position.lat){
          this.inSenic = this.isInSenic(this.position.lng,this.position.lat);
          if(this.rectangle&&this.inSenic == false){
            this.$toast("抱歉，您不在当前景区");
          }else {
            this.moveCenter(this.position.lng,this.position.lat);
          }
          this.addMapControl();
        }else {
          this.$toast('未获取到定位权限，请重启微信后再尝试');
        }
      },
      //获取当前定位
      getPosition: function(type){
        let self = this;
        console.log('getPosition');
        if(self.isMobile){
          wxGetPosition(function(res){
            var lat = res.latitude;
            var lng = res.longitude;
            nextStep(lat,lng,type)
          });
        }else {

          Map.plugin('AMap.Geolocation', function() {
            var geolocation = new AMap.Geolocation({
              enableHighAccuracy: true,//是否使用高精度定位，默认:true
              timeout: 10000          //超过10秒后停止定位，默认：无穷大
            });
            geolocation.getCurrentPosition();
            AMap.event.addListener(geolocation, 'complete', onComplete);//返回定位信息
            AMap.event.addListener(geolocation, 'error', onError);      //返回定位出错信息
          });


          //解析定位结果
          function onComplete(data) {
            var lat = data.position.lat;  //获取到当前位置的经纬度
            var lng = data.position.lng;

            nextStep(lat,lng,type)
          }

          //解析定位错误信息
          function onError(data) {
            if( type == 1 && self.isMobile){
              self.$toast("抱歉，定位失败");
            }else {
              console.log("定位失败");
            }
          }
        }

        function nextStep(lat,lng,type){
          if(lat == "" && lng == ""){
            if( type == 1 && self.isMobile){
              self.$toast("抱歉，定位失败");
            }else {
              console.log("定位失败");
            }
          }else{
            self.position = { lat: lat, lng: lng };
            setStore("position", self.position);

            self.inSenic = self.isInSenic(self.position.lng,self.position.lat);

            //地图对象存在时 更新位置坐标
            if (Map) {
              if (self.rectangle && self.inSenic == false && self.showInSenicTips == true) { //不在景区 && 显示是否在景区的提示
                self.$toast("抱歉，您不在当前景区");
                self.showInSenicTips = false;
              }
              if(type == 1 && self.inSenic){
                self.moveCenter(self.position.lng,self.position.lat);
              }
              self.addMapControl();
            }
          }
        }



      },
      //添加定位点
      addMapControl: function() {
        try {
          if (this.isMarkLocation()) {
            this.locationMarker.setPosition([parseFloat(this.position.lng), parseFloat(this.position.lat)]);
          } else {
            let icon = require('../../assets/icon_24_ind.png');
            this.locationMarker = new AMap.Marker({
              content: '<img  style="transform: translateX(-50%) rotate(0deg);" src="' + icon + '" id="guide-now" class="guide-now"/>',
              offset: new AMap.Pixel(0, 0),
              zIndex: 110,
              position: [parseFloat(this.position.lng), parseFloat(this.position.lat)],
              map: Map
            });
            this.locationMarker.type = "local";

            setmarkeroffset();
            Map.on("zoomchange", function(e){
              setmarkeroffset();
            });
            // 高德缩放地图时  覆盖物标记会偏移，因此处理下偏移量
            let self = this;
            function setmarkeroffset() {
              let maxZoom = Map.getZooms()[1] || 20;
              let zoom = Map.getZoom();
              let c = maxZoom - zoom;
              if (c < 5) {
                self.locationMarker.setOffset(new AMap.Pixel(c * 10, c * 10));
              } else {
                self.locationMarker.setOffset(new AMap.Pixel(4 * 10, 4 * 10));
              }
            }
          }
        } catch (e) {
          console.log("添加定位点失败:", e);
        }
      },
      //判断是否在景区
      isInSenic: function(lng,lat) {
        if(this.rectangle){
          let isInSenic = this.rectangle.contains([parseFloat(lng),parseFloat(lat)]);
          return isInSenic;
        }
      },
      // 判断当前地图上是否存在定位点
      isMarkLocation: function() {
        if (Map) {
          let markers = Map.getAllOverlays();
          for (let i = 0, len = markers.length; i < len; i++) {
            if (markers[i].type && markers[i].type === "local") {
              return true;
            }
          }
          return false;
        }
      },
      // 监听设备陀螺仪转动
      deviceRotate: function() {
        let self = this;
        let ua = navigator.userAgent.toLowerCase();
        if (window.DeviceOrientationEvent) {
          if (/android/.test(ua)) {
            window.addEventListener("deviceorientationabsolute",function(){
              let rote = Math.round(360 - event.alpha);
              rotefun(rote);
            })
          } else {
            if (typeof DeviceOrientationEvent.requestPermission === "function") {
              DeviceOrientationEvent.requestPermission().then(function(permissionState){
                if (permissionState === "granted") {
                  console.log("已授权");
                  // 已经授权成功时，直接监听，否则请求授权
                  window.addEventListener("deviceorientation", function(){
                    let rote = event.webkitCompassHeading;
                    rotefun(rote);
                  },false);
                } else {
                  console.log("已拒绝");
                  self.$toast("您已拒绝方向访问，请清除浏览器缓存再试");
                  self.pointor = false;
                }
              }).catch(function(){
                console.log("未授权");
                // 如果未授权则需要 进行授权
                self.$confirm({
                  title: '提示',
                  content: '需要授权访问设备方向，请点击确认以使用地图功能',
                  component: wxConfirm
                }).then(function(res){
                  if(res == 'success') {
                    DeviceOrientationEvent.requestPermission().then(function(permissionState){
                      console.log(permissionState);
                      if (permissionState === "granted") {
                        window.addEventListener("deviceorientation", function(){
                          let rote = event.webkitCompassHeading;
                          rotefun(rote);
                        }, false);
                      } else {
                        self.$toast("您已拒绝方向访问，请清除浏览器缓存再试");
                        self.pointor = false;
                      }
                    });
                  }
                })
              });
            } else {
              console.log(`该设备不支持方向获取`);
              self.pointor = false;
            }
          }
        }

        function rotefun(rote){
          let markderDom = document.getElementById("guide-now");
          if (markderDom) {
            markderDom.style.transform = 'translateX(-50%) rotate('+ rote +'deg)';
            //存储上一次的角度信息
            window.locationRotate = rote;
          }
        }
      },

      //经纬度换算成距离
      getDistance: function(lat1, lng1, lat2, lng2) {
        var EARTH_RADIUS = 6378137.0;    //单位M
        lat1 = Number(lat1);
        lat2 = Number(lat2);
        lng1 = Number(lng1);
        lng2 = Number(lng2);

        function getRad(d) {
          var PI = Math.PI;
          return d * PI / 180.0;
        }

        var f = getRad((lat1 + lat2) / 2);
        var g = getRad((lat1 - lat2) / 2);
        var l = getRad((lng1 - lng2) / 2);

        var sg = Math.sin(g);
        var sl = Math.sin(l);
        var sf = Math.sin(f);

        var s, c, w, r, d, h1, h2;
        var a = EARTH_RADIUS;
        var fl = 1 / 298.257;

        sg = sg * sg;
        sl = sl * sl;
        sf = sf * sf;

        s = sg * (1 - sl) + (1 - sf) * sl;
        c = (1 - sg) * (1 - sl) + sf * sl;

        w = Math.atan(Math.sqrt(s / c));
        r = Math.sqrt(s * c) / w;
        d = 2 * w * a;
        h1 = (3 * r - 1) / 2 / c;
        h2 = (3 * r + 1) / 2 / s;

        var re = (Math.round(d * (1 + fl * (h1 * sf * (1 - sg) - h2 * (1 - sf) * sg))) / 1000);
        if (isNaN(re)) return "未知距离";
        if (re > 10000) return "未知距离";

        if(re > 0 && re < 1){
          return re.toFixed(2)*1000 + 'M';
        }else {
          return re.toFixed(2) + 'KM';
        }
      },

      //找厕所
      searWC: function (type){
        var self = this;
//        AMap.plugin(['AMap.PlaceSearch'], function() {
        AMap.service(["AMap.PlaceSearch"], function() {
          var placeSearch = new AMap.PlaceSearch({ //构造地点查询类
            children: 1,
            pageSize: 20,  //单页显示结果条数   默认值：10
            showCover: false,  //在使用map属性时，是否在地图上显示周边搜索的圆或者范围搜索的多边形，默认为true
            autoFitView: true  //搜索结束后，是否自动调整地图视野使绘制的Marker点都处于视口的可见范围
          });

          //var cpoint = new AMap.LngLat(self.shop.lng, self.shop.lat); //中心点坐标
          var cpoint = new AMap.LngLat(self.position.lng,self.position.lat); //当前定位坐标
          var txt = (type=='wc'?'厕所':'出口|入口');
          placeSearch.searchNearBy(txt, cpoint, 500, function(status, result) {
            if(result && result.poiList){
              self.wclist = result.poiList.pois;
              self.noWc = false;
              self.appendMarker(result.poiList.pois,type);
              self.navList=2;
              self.showList=true;
              self.moveCenter(self.position.lng,self.position.lat);
            }else {
              self.noWc = true;
              self.$toast('定位附近暂无'+txt)
            }
          });
        });
      },

      //清除地图点标记
      clearMap: function() {
        if(this.markerList.length > 0){
          Map.remove(this.markerList);
          this.markerList = [];
        }
      },
      //添加点标记
      appendMarker: function (list,type){
        if(this.markerList.length > 0 && this.markerList[0].type && this.markerList[0].type == type){
          return false;
        }
        this.clearMap(type);
        let self = this;
        if (list && list.length > 0) {

          list.forEach(function(data,index){
            let lng,lat,markerIcon,activeClass;
            let name = data.name;
            let markerId= data.id;
            let zIndex = 100;
            if(type == 'spot'){ //景点
              lng = parseFloat(data.lng);
              lat = parseFloat(data.lat);
              markerIcon = require('../../assets/icon_41.png');
              activeClass = self.currSpot&&self.currSpot.id == markerId ? "active" : ""; // 是否当前选中的景点
              zIndex = self.currSpot&&self.currSpot.id == markerId ? 105 : 100;
            }else if(type == 'wc' || 'exit'){ //厕所
              lng = data.location.lng;
              lat = data.location.lat;
              if(type == 'wc'){
                markerIcon = require('../../assets/icon_42.png');
              }else {
                markerIcon = require('../../assets/icon_43_1.png');
              }

              activeClass = self.currWC&&self.currWC.id == markerId ? "active" : ""; // 是否当前选中的厕所
              zIndex = self.currWC&&self.currWC.id == markerId ? 105 : 100;
            }
            if (!lng || !lat) {
              return false;
            }

            let markerContent = '<div class="mapMarker mapMarkerId'+ markerId + ' ' + type + ' ' + activeClass +'" id="mapMarkerId'+ markerId +'"> ' +
              '<div class="mapMarker-img">' +
              '<img src="'+ markerIcon +'" alt="'+ name +'" />' +
              '</div> ' +
              '<p class="mapMarker-name">'+ name +'</p> ' +
              '</div>';

            let marker = new AMap.Marker({
              position: [lng, lat],
              content: markerContent,
              offset: new AMap.Pixel(0, 0),
              zIndex: zIndex,
              map: Map
            });
            // 设置标记点数据
            marker.selfData = data;
            marker.type = type;
            self.markerList.push(marker);


            if(type == 'spot'){ //景点
              marker.on("click", function(e){
                let selfData = e.target.selfData;
                self.currSpot = selfData;
                let className = '.mapMarkerId' + selfData.id;
                self.onMarkerUpdate(marker, className);
                self.showList = true;
                self.spotid = selfData.id;

                if(self.vrbagid){
                  console.log('vr-list-p'+selfData.id);
                  self.scollToDom('vr-list-p'+selfData.id,'VoiceScoll');
                  var ind = self.getIndex(self.voicelist,self.spotid);
                  self.currIndex = ind;

                  self.openVR(ind)
                }else {
                  self.scollToDom('voice-list-p'+selfData.id,'VoiceScoll');
                  if(!self.formGuide){ //不是从导游详情进入
                    self.getGuidelist();
                    if(self.currIndex>=0 && self.currGuide&&self.currGuide.id){
                      var ind = self.getIndex(self.voicelist,self.spotid);
                      self.playVideoClick(ind)
                    }
                  }else {
                    var ind = self.getIndex(self.voicelist,self.spotid);
                    self.playVideoClick(ind)
                  }
                }

              });
            }else if(type == 'wc'||type == 'exit'){ //厕所
              marker.on("click", function(e){
                let selfData = e.target.selfData;
                self.currWC = selfData;
                let className = '.mapMarkerId' + selfData.id;
                self.onMarkerUpdate(marker, className);
                self.showList = true;
                self.scollToDom('spot-liWC'+selfData.id,'WCScoll')
              });
            }
          });
        }
      },
      //地图标记点击后的通用逻辑处理
      onMarkerUpdate: function(marker,className) {
        this.clearAllSelect(); // 主动移除地图上相关标记点状态
        // 若 旧的记录的标记点存在时，先移除其选中状态
        if (this.currMarkerData.className) {
          let curel = document.querySelector(this.currMarkerData.className);
          if (curel) {
            this.removeClass(curel, "active");
          }
        }
        this.currMarkerData.className = className; // 设置当前点击的标记点元素

        // 点击时切换选中
        let el = document.querySelector(className);
        if(el){
          this.addClass(el, "active");
        }

        // 将当前选中的标记层级设置靠前
        if (this.currMarkerData.marker) {
          this.currMarkerData.marker.setzIndex(100);
        }
        marker.setzIndex(105);
        this.currMarkerData.marker = marker;
      },
      //清除地图上点的选中样式
      clearAllSelect: function() {
        let self = this;
        let markerDom = document.querySelectorAll(".amap-marker .active");
        if (markerDom.length) {
          markerDom.forEach(function(item){
            self.removeClass(item, "active");
          })
        }
      },
      removeClass: function(obj, cls) {
        if (this.hasClass(obj, cls)) {
          var reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
          obj.className = obj.className.replace(reg, " ");
        }
      },
      hasClass: function(obj, cls) {
        return obj.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
      },
      addClass: function(obj, cls) {
        if (!this.hasClass(obj, cls)) obj.className += " " + cls;
      },

      //点击解说
      clickFun1(){
        if(this.formGuide){ //从导游专辑详情页过来
          this.openGuide(this.bagid);
        }else {
          this.navList=1;
          this.showList=true;
          this.getGuidelist();

          if (this.shop.lng && this.shop.lat) { // 设置景区中心点为地图中心点f
            this.moveCenter(this.shop.lng, this.shop.lat);
          }
        }
        this.appendMarker(this.spotlist,'spot')
      },

      //页面滑动到指定标签id位置
      scollToDom(elmid,boxid){
        let self = this;
        self.$nextTick(function(){
          setTimeout(function(){
            var dom = document.getElementById(elmid);
            var box = document.getElementById(boxid);
            if(dom && dom!=null){
              var dis = dom.offsetTop - box.offsetTop;
              if(dom.parentNode && dom.parentNode.className.indexOf("vr-list")>-1){ //VR列表有父级节点
                dis = dom.offsetTop + dom.parentNode.offsetTop - box.offsetTop
              }
              box.scrollTo(0,parseInt(dis-10));
            }
          },500)
        })
      },

      //跳到景点详情页
      toDetail: function (id){
        this.$router.push({
          path: `/video-vr?${'id='+this.vrbagid+'&spotid='+ id+'&shopid='+this.shopid+'&bagtype=2'}`
        });
      },

      //打开地图
      openMap: function (type,item){
        if(type == 'spot'){
          wxOpenMapLocation(item.lat, item.lng, item.name, item.address || '');
        }else if(type == 'wc'){
          wxOpenMapLocation(item.location.lat, item.location.lng, item.name, item.address || '')
        }
      },

      //切换语音
      spotClick(ind){
        this.currSpot = this.spotlist[ind];
        this.moveCenter(this.currSpot.lng,this.currSpot.lat)
        if(this.markerList.length > 0 && this.markerList[0].type && this.markerList[0].type == 'spot'){
          let className = '.mapMarkerId' + this.currSpot.id;
          this.onMarkerUpdate(this.markerList[ind], className);
        }else {
          this.appendMarker(this.spotlist,'spot');
        }
      },

      //点击语音收听
      playVideoClick(index){
        if(this.buy == true || index < 2){
          playVideo(this,index);

          var ind = this.getIndex(this.spotlist,this.voicelist[index].spotid,2);
          this.spotClick(ind)
        }else {
          this.buyVideo();
          this.$toast('请先购买该张专辑')
        }
      },

      //点击上一曲
      prevPlay(){
        let currIndex = this.currIndex == 0 ? (this.voicelist.length -1) : (parseInt(this.currIndex) - 1);
        this.playVideoClick(currIndex);
      },
      //点击下一曲
      nextPlay(){
        let currIndex = (this.currIndex == this.voicelist.length -1) ? 0 : (parseInt(this.currIndex) + 1);
        this.playVideoClick(currIndex);
      },

      //点击购买，调用下订单公用方法
      buyVideo(item){
          let self = this;
          setStore("source", {"source": "map"});
          if(item){
            creatOrder(this,item,"",function(data){
              if(data){
                self.buy = true;
              }
            },true)
          }else{
            creatOrder(this,this.currGuide,"",function(data){
              if(data){
                self.buy = true;
              }
            },true)
          }

      },

      //格式化时间
      initTime: function (time) {
        let minute = parseInt(time / 60);
        let second = parseInt(time % 60);
        minute = minute >= 10 ? minute : "0" + minute;
        second = second >= 10 ? second : "0" + second;
        return minute + ":" + second;
      },


      //获取VR专辑详情
      async getVrDesc(vrbagid){
        var self = this;

        let res = await getVideoPlay({
          openid: this.userInfo.openid,
          bagid: vrbagid,
          siteid: '',
          sregion: '',
          page:1,
          rows: 0
        });

        if (res.errcode === "00000"){
          this.res = res.data;
          this.bagInfo = res.data.bag;
          this.shopid = this.bagInfo.shopid;
          this.voice = res.data.voice;

          var voiceList = res.data.voiceList, arr=[];
//          for(var i=0; i<voiceList.length; i++){
//            if(voiceList[i].lat && voiceList[i].lng){
//              arr.push(voiceList[i])
//            }
//          }
//          this.bagList = arr;
//          this.voicelist = arr;
          this.bagList = voiceList;
          this.voicelist = voiceList;

          this.buy = (res.data.bag.isbuy == true || res.data.bag.price <= 0) ? true : false;
          this.currGuide = res.data.bag;
          this.currGuide.shopid = this.shopid;

          this.navList = 3;

          this.getSrtTxtFun();

          if(this.form == "spot"){
            this.index1 = this.getIndex(this.bagList,this.spotid);
          }

        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },
      //获取当前视频锚点列表
      async getVrmaoListFun(id){
        let res = await getVrmaoList({
          id: id
        });
        if (res.errcode === "00000"){
          this.maolist = res.data.list;
        }
        this.isBegin = false;
      },
      //锚点事件点击提交
      async getVrmaoUploadFun(id){
        let res = await getVrmaoUpload({
          id: id
        });
      },

      //点击播放VR
      playVRClick(index){
        this.currIndex = index;

        var ind = this.getIndex(this.spotlist,this.voicelist[index].spotid,2);
        this.spotClick(ind)

      },

      //点击上一曲
      prevPlay(){
        var playIndex = parseInt(this.currVRindex) == 0 ? (this.bagList.length -1) : (parseInt(this.currVRindex) - 1);
        this.openVR(playIndex);
      },
      //点击下一曲
      nextPlay(){
        var playIndex = (parseInt(this.currVRindex) == this.bagList.length -1) ? 0 : (parseInt(this.currVRindex) + 1);
        this.openVR(playIndex);
      },

      //打开全景视频
      openVR(index){
        this.videoAlert=1;
        if(this.currVRindex<0){
          this.videoAlertMask=1;
        }

        if(MyPlayerObj && MyPlayerObj.api_getVideoCurTime()>0){
          MyPlayerObj.api_setVideoCurTime(0);
        }
        this.initVR(index);

//    this.switchScneNumber = index;
//    this.currIndex = index;
//    if(this.voicelist[index].lat && this.voicelist[index].lng){
//      var ind = this.getIndex(this.spotlist,this.voicelist[index].spotid,2);
//      this.spotClick(ind)
//    }
      },
      //关闭字幕计数器
      clearTxt: function (){
        if(txtTimer){
          window.clearTimeout(txtTimer);
          txtTimer = null
        }
      },
      //关闭全景
      closeVR(){
        var self = this;
        self.videoAlert=0;
        self.exitScne();
        self.clearTxt();
        self.MyPlayerStop = true
      },

      initVR(index) {
        var self = this;
        self.MyPlayerStop = false;
        self.switchScneNumber = index;
        self.currIndex = index;
        var panoDesk = document.getElementById("panoDesk");
        if(panoDesk.innerHTML == ""){
          if(self.voicelist[index].lat && self.voicelist[index].lng){
            var ind = self.getIndex(self.spotlist,self.voicelist[index].spotid,2);
            self.spotClick(ind);
          }

          self.getVrmaoListFun(self.bagList[index].id);

          this.vrIconShow = true;

          var scenesArr = self.getScenesArr();
          this.scenesArr = scenesArr;
          var params = {
            /*播放器参数配置*/
            container: document.getElementById("panoDesk"),
            name: "SceneViewer",
            loadingImg: '<img  src="'+require('../../assets/load.gif')+'" style="display:block;width:auto;height:12px" />',
            isDBClick: true,
            isGyro: false,
            scenesArr: scenesArr,
            initSceneId: index,
            initOverCallBack: function () { //SDK初始完成回调
              console.log("SDK初始完成回调");
              self.cutTime=-1;
              MyPlayerObj = this;
            },
            loadedStartCallBack: function(){ //播放器开始实例化
              console.log("播放器开始实例化");
              self.addMenuClick();
              self.changeVideoQuality();
            },
            loadedCallBack: function() { //场景加载完成回调
              console.log("视频场景加载完成回调");
              self.isBegin = true;
              if(self.bagInfo.isLittlePlanetEffect){
                MyPlayerObj.api_normalView(2);
              }
              self.vrPointStyleFun()
              playRecord(self.bagList[self.switchScneNumber].id);
              if(self.preNumber!=self.switchScneNumber || self.bagList.length==1){
    //                MyPlayerObj.api_setVideoCurTime(0);
              }

            },
            errorCallBack: function (e) { //播放器异常回调
              console.log("错误状态：" + e);

              self.$alert({
                title: 'VR视频播放失败',
                content: '视频加载失败，刷新页面重新观看',
                btnText: '刷新页面'
              }).then(function(res){
                if(res == 'ok') {
                  location.reload();
                }
              });

            },
            videoPlayEndCallBack: function(e){ //视频播放结束回调（isVideoLoop为false 启用）
              console.log("视频播放结束回调");
              self.vrContShow=0;
              self.clearTxt();
              MyPlayerObj.api_setVideoCurTime(0);
              self.nextScne();
            },
            videoPlayerCallBack: function(){
              self.clearTxt();
              var txtarr = self.bagList[self.switchScneNumber].txtarr;
              if(txtarr && txtarr.length>0){
                self.showSrtTxt(txtarr);
              }
              self.isBegin = true;
            },
            videoTogglePlayCallBack: function(){
              if (!MyPlayerObj.api_getVideoPlayStatus()) {
                self.clearTxt();
              }
            },
            videoCanPlayerCallBack: function(){
              console.log('videoCanPlayerCallBack')
              if(!MyPlayerStop){
                // 获取当前播放时间
                let curr = MyPlayerObj.api_getVideoCurTime();
                // 缓存的最新帧
                var videoDom = MyPlayerObj.api_getVideoDom();
                if (!videoDom) return;
                var buf = videoDom.buffered;
                var leg = buf.length - 1;
                if (leg < 0) return;
                var buffer = buf.end(leg).toFixed(1);
                // 计算延迟 如果延迟大于5s（自己定义）认为卡顿
                if(buffer - curr >= 6 && self.cutTime==-1){
                  console.log('卡顿了1')
                  self.bufferCut();
                }
              }

            },
            scenePanTiltFovChangerCallBack: function(){
              self.vrPointStyleFun()
            }
          };

          //todo：配置工具栏的多码率格式
          var TConfig = {
            videoQuality: 1,
            videoList: [
              {
                "Text": "4G流畅",
                "Quality": 1,
                "MP4": "http://cache.utovr.com/5b8d3395d6024c7e99c107627ae9c93c/L1_zgucy3i1hcllftu5.mp4",
                "RTMP": null
              },
              {
                "Text": "5G高清",
                "Quality": 2,
                "MP4": "http://cache.utovr.com/5b8d3395d6024c7e99c107627ae9c93c/L3_ngeaxawx1c88u8de.mp4",
                "RTMP": null
              }]
          };
          initLoad(params, function (playMode) {
            self.setToolBoxW(index);
          }, TConfig)
        }else {
          this.switchScne(index);
          (document.getElementById("toolBar")).scrollTo(document.getElementById("toolBtn"+this.bagList[index].id).offsetLeft,0)
        }
      },
      //视频锚点定位
      vrPointStyleFun: function (){
        var self = this;
        if(MyPlayerObj){
          var maolist = self.maolist;
          for(var i=0; i<maolist.length; i++){
            var xy = MyPlayerObj.api_sphereToScreen(maolist[i].pan,maolist[i].tilt);
            maolist[i]['vrPointStyle'] = {left: xy.x+'px', top: xy.y+'px'}
            self.$set(self.maolist, i, maolist[i]);
          }
          self.maolist = maolist;
        }
      },
      //播放卡顿处理
      bufferCut: function (time){
        var self = this;
        self.$alert({
          title: 'VR视频播放卡顿',
          content: '因网速原因，视频播放缓慢，先去听语音解说吧',
          btnText: '继续等待'
        });
        self.cutTime = 1;

      },
      showSrtTxt:function(txtarr){
        var self = this;
        txtTimer = window.setTimeout(function(){
          var time = MyPlayerObj.api_getVideoCurTime();
          if(Math.round(time)>=self.bagList[self.switchScneNumber].totaltime){
            self.clearTxt();
            return
          }else {
            for(var i=0; i<txtarr.length; i++){
              if(time>txtarr[i].startTime && time<txtarr[i].endTime){
                self.txtcurr = txtarr[i].content;
              }
            }
            self.showSrtTxt(txtarr);
          }
        },400);
      },
      //重新计算底部预览图部分的长度
      setToolBoxW(index){
        let self = this;
        self.$nextTick(function () {
          var w = self.isMobile?130:160;

          self.toolBoxW = w * self.bagList.length;
          setTimeout(function(){
            (document.getElementById("toolBar")).scrollTo(document.getElementById("toolBtn"+self.bagList[index].id).offsetLeft,0)
          },800);

        })
      },
      //追加菜单元素点击事件
      addMenuClick(){
        console.log("追加菜单元素点击事件");
        setTimeout(function(){
          var dom = document.getElementById("videoMenu");
          if(dom && dom != null){
            dom.parentNode.removeChild(dom);
          }
          var parent = document.getElementById("videoBG");
          var child = document.getElementById("videoFullScreen");
          var menu = document.createElement("div");
          menu.setAttribute('id', 'videoMenu');
          menu.setAttribute('class', 'floatR floatW videoMenu2');
          parent.insertBefore(menu,child.nextSibling);

          var videoToolbar = document.getElementById("videoToolbar");
          var toolBar = document.getElementById("toolBar");
          toolBar.setAttribute('class', 'toolBar');

          var event = this.isMobile?"touchstart":"click";
          menu.addEventListener(event, function(e){
            e.stopPropagation();
            menuFun();
          }, false);

          function menuFun(){
            var menuClass = menu.getAttribute("class");
            if(menuClass == "floatR floatW videoMenu2"){ //隐藏底部菜单
              menu.setAttribute('class', 'floatR floatW videoMenu1');
              toolBar.setAttribute('class', 'toolBar toolBar1');
              videoToolbar.setAttribute('class', 'videoToolbar');
            }else {
              menu.setAttribute('class', 'floatR floatW videoMenu2');
              toolBar.setAttribute('class', 'toolBar');
              videoToolbar.setAttribute('class', '');
            }
          }
        },800);

      },
      //切换视频清晰度
      changeVideoQuality(){
        var self = this;
        setTimeout(function(){
          var quality1 = document.getElementById("1");
          var quality2 = document.getElementById("2");
          var curVideoText = document.getElementsByClassName("curVideoText")[0];
          if(curVideoText) curVideoText.innerHTML = '4G流畅';
          quality1 && quality1.setAttribute('class', 'videoListDom videoListDomCheck');
          quality2 && quality2.setAttribute('class', 'videoListDom');

          var event = self.isMobile?"touchstart":"click";
          quality1 && quality1.removeEventListener(event, function(){}, false);
          quality1.addEventListener(event, function(e){
            e.stopPropagation();
            console.log('quality1')
            curVideoText.innerHTML = '4G流畅';
            quality1.setAttribute('class', 'videoListDom videoListDomCheck');
            quality2.setAttribute('class', 'videoListDom');
            MyPlayerObj.api_changeVideoPath(self.bagList[self.switchScneNumber].url['720'])
          }, false);

          quality2 && quality2.removeEventListener(event, function(){}, false);
          quality2.addEventListener(event, function(e){
            e.stopPropagation();
            console.log('quality2')
            curVideoText.innerHTML = '5G高清';
            quality1.setAttribute('class', 'videoListDom');
            quality2.setAttribute('class', 'videoListDom videoListDomCheck');
            MyPlayerObj.api_changeVideoPath(self.bagList[self.switchScneNumber].url['1080'])
          }, false);

        },800)
      },
      //重组视频数据赋值给VR播放器
      getScenesArr() {
        var scenesArr = [];
        var voiceList = this.bagList;
        var self = this;
        voiceList.map(function(item, index){
          scenesArr.push(Object.assign({},{
            sceneId: item.number,
            sceneName: item.spotname,
            sceneFilePath: item.url['720'],
            sceneType: "Video",
            isVideoLoop: false,
            isVideoAutoPlay: true,
            initFov: item.initFov || 100, //默认值：90，当前场景的初始fov值 范围（10~150）
            initPan: item.rotate || 0,  //默认180，当前场景的初始pan值 范围（0 ~ 360）
            isLittlePlanetEffect: (self.bagInfo.isLittlePlanetEffect==1?true:false), //默认不加载小行星效果状态
          }))
        });
        return scenesArr;
      },
      preScne(){
        var index = parseInt(this.switchScneNumber) == 0 ? (this.bagList.length -1) : (parseInt(this.switchScneNumber) - 1);
        this.switchScne(index)
      },
      nextScne(){
        var index = (parseInt(this.switchScneNumber) == this.bagList.length -1) ? 0 : (parseInt(this.switchScneNumber) + 1);
        this.switchScne(index)
      },
      switchScne(index){
        if(index != this.switchScneNumber){
          this.preNumber = this.switchScneNumber;
          this.switchScneNumber = index;
          MyPlayerObj.api_setVideoCurTime(0);
        }

        this.getVrmaoListFun(this.bagList[index].id);

        console.log( document.getElementsByClassName("curVideoText")[0].innerHTML);
        var curVideoText = document.getElementsByClassName("curVideoText")[0];

        var scenesArr = this.scenesArr;
        if(curVideoText.innerHTML == '4G流畅'){
          MyPlayerObj.api_changeVideoPath(this.bagList[index].url['720'])
        }else {
          MyPlayerObj.api_changeVideoPath(this.bagList[index].url['1080'])
        }
        MyPlayerObj.api_setPanTiltFov(this.bagList[index].rotate || 0, 0, this.bagList[index].initFov|| 100); //设置当前视口的Pan，tilt，fov值

        var videoMenu = document.getElementById("videoMenu");
        var toolBar = document.getElementById("toolBar");
        var videoToolbar = document.getElementById("videoToolbar");
        var menuClass = videoMenu.getAttribute("class");
        if(menuClass == "floatR floatW videoMenu2"){ //隐藏底部菜单
          videoMenu.setAttribute('class', 'floatR floatW videoMenu1');
          toolBar.setAttribute('class', 'toolBar toolBar1');
          videoToolbar.setAttribute('class', 'videoToolbar');
        }


        this.currIndex = index;
        this.scollToDom('vr-list-p'+this.bagList[index].spotid,'VoiceScoll');
        if(this.voicelist[index].lat && this.voicelist[index].lng){
          var ind = this.getIndex(this.spotlist,this.voicelist[index].spotid,2);
          this.spotClick(ind)
        }

      },
      enterScne(){
        MyPlayerObj && MyPlayerObj.api_enterVRModel();
      },
      exitScne(){
        MyPlayerObj && MyPlayerObj.api_setVideoPause();
//        document.getElementById("panoDesk").innerHTML = "";
      },

      //判断横竖屏
      renderResize() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;
        var gyro = document.getElementById("videoGyro");
        var menu = document.getElementById("videoMenu");
        var videoToolbar = document.getElementById("videoToolbar");
        var toolBar = document.getElementById("toolBar");
        if(width > height) {
          this.windowResize = 1;
    //          MyPlayerObj && MyPlayerObj.api_OpenGyro();
    //          gyro && gyro.setAttribute('class', 'floatR floatW videoGyro2');
          menu && menu.setAttribute('class', 'floatR floatW videoMenu1');
          toolBar && toolBar.setAttribute('class', 'toolBar toolBar1');
          videoToolbar && videoToolbar.setAttribute('class', 'videoToolbar');
        }else{
          this.windowResize = 0;
          menu && menu.setAttribute('class', 'floatR floatW videoMenu2');
          toolBar && toolBar.setAttribute('class', 'toolBar');
          videoToolbar && videoToolbar.setAttribute('class', '');
        }
      },

      /**
       * 把 SRT 格式的字幕文件解析为字幕的对象数组，格式为:
       */
      parseSrtSubtitles:function(srt) {
        var subtitles = [];
        var textSubtitles = srt.split('\r\n\r\n'); // 每条字幕的信息，包含了序号，时间，字幕内容
        function getSeconds(val){
          let arr = val.split(/\,|\./)
          let sec = 0
          let a = arr[0].split(':')
          sec = Number(a[0])*60*60+Number(a[1])*60+Number(a[2])+arr[1]/1000
          return sec
        }
        for (var i = 0; i < textSubtitles.length; ++i) {
          var textSubtitle = textSubtitles[i].split('\r\n');

          if (textSubtitle.length >= 2) {
            var sn = textSubtitle[0]; // 字幕的序号

            var reg = /^(\d{2}):(\d{2}):(\d{2})[\.,](\d{1,3}) --\> (\d{2}):(\d{2}):(\d{2})[\.,](\d{1,3})/g;
            var regResult = reg.exec(textSubtitle[1]);
            var timeSplit = regResult[0].split(' --> ');
            var startTime = getSeconds(timeSplit[0]);
            var endTime = getSeconds(timeSplit[1]);

            var content   = textSubtitle[2]; // 字幕的内容

            // 字幕可能有多行
            if (textSubtitle.length > 2) {
              for (var j = 3; j < textSubtitle.length; j++) {
                content += '\n' + textSubtitle[j];
              }
            }

            // 字幕对象
            var subtitle = {
              sn: sn,
              startTime: startTime,
              endTime: endTime,
              content: content
            };
            subtitles.push(subtitle);
          }
        }
        return subtitles;
      },
      //解析字幕
      getSrtTxtFun: function (){
        var self = this;
        var bagList = self.bagList;
        for(var i=0; i<bagList.length; i++){
          var srturl = bagList[i].srturl;
          if(srturl){
            self.requestTxt(srturl,bagList,i)
          }
        }
      },
      requestTxt: function (srturl,bagList,i){
        var self = this;
        getSrtTxt(srturl,function(res){
          self.bagList[i]['txtarr'] = self.parseSrtSubtitles(res);
          self.$set(bagList, i, bagList[i]);
        })
      },

      //热点点击事件
      vrContShowFun: function (item){
        this.vrContShow=item;
        this.getVrmaoUploadFun(item.id);
        console.log(this.bagList[this.switchScneNumber].allimg && !this.vrContShow.cont)

        if(item.cont){
          var cont = item.cont;
          var imageArr = [];
          cont.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {  //match表示img元素，capture表示img地址
            imageArr.push(capture);
        });
          this.imageArr = imageArr;
          console.log(this.imageArr)
        }
      },

      //富文本中图片点击事件
      imageEnlargement(e){
        if (e.target.nodeName == 'IMG') {//判断点击富文本内容为img图片
          wxImgPreview(e.target.currentSrc,this.imageArr);
        } else {
          console.log("点击内容不为img")
        }
      },
      //图片预览
      seeImg(ind,imgs){
        wxImgPreview(imgs[ind],imgs);
      },


    },
    watch:  {

    },
    components: {
      AlertComment,
      AlertPoster,
      P400
    },
    //格式化数据
    filters: {
      //格式化距离
      initDistance: function (num) {
        if(num>1000){
          num = (num/1000).toFixed(2)+'KM'
        }else {
          num = num+'M'
        }
        return num;
      },
      //格式化数字
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      //格式化时间
      initTime: function (time) {
        let minute = parseInt(time / 60);
        let second = parseInt(time % 60);
        minute = minute >= 10 ? minute : "0" + minute;
        second = second >= 10 ? second : "0" + second;
        return minute + ":" + second;
      },
    },
    directives: {
      focus: {
        inserted: function (el) {
          el.focus()
        }
      }
    }
  }

</script>

<style>
  .amap-logo,.amap-copyright{ display: none!important; }
  .map-box .amap{position:absolute;left:0;top:0;width:100%;height:100%}
  .amap  .guide-now{position:relative; width:.41rem!important;height:.53rem!important; }
  .amap .mapMarker{position:relative;display:block; width:.49rem;height:.58rem;transform: translate(-50%,-100%);}
  .amap .mapMarker-img{ display:block; width:.49rem;height:.58rem; }
  .amap .mapMarker-img img{width:100%;height:100%; }
  .amap .mapMarker .mapMarker-name{ position: absolute; bottom: -.45rem; left: 50%;transform: translateX(-50%); white-space: nowrap; padding: .03rem .1rem; font-size: .24rem; color: #faaf39; border: .01rem solid #faaf39; border-radius: .05rem; background-color: #fff; }
  .amap .mapMarker.active .mapMarker-name{ color: #fff; background-color: #faaf39; }
  .amap .mapMarker.wc .mapMarker-name{  border: .01rem solid #8cc816; color: #8cc816; }
  .amap .mapMarker.wc.active .mapMarker-name{ color: #fff; background-color: #8cc816; }

  /*VR播放*/
  #videoFullScreen{ display: none!important; }
  #panoDesk{ position: absolute; width: 100%; height: 100%; left: 0; top: 0; overflow: hidden; }
  .toolBar{ position: absolute; bottom: 65px;z-index: 0; width: 100%; height: 62px; text-align: center; overflow-x: auto; -webkit-transition: all ease .3s; -moz-transition: all ease .3s; transition: all ease .3s;  }
  .toolTxt{ position: absolute; left: 10%; bottom: 130px;z-index: 0; width: 80%; text-align: center; font-size: .34rem; letter-spacing: 2px;font-weight: bolder; font-family: 'simsu'; color: #fff; text-shadow: -1px 1px 0 #000, 1px 1px 0 #000, 1px -1px 0 #000,-1px -1px 0 #000; }
  .toolBar.toolBar1 { height: 0; overflow: hidden; }
  .toolBox { height: 62px; overflow-y: hidden; }
  .toolBtn { position: relative; width: 108px; height: 60px; margin-right: 10px; float: left; border: 1px solid #fff; overflow: hidden; }
  .toolBtn > img{ width: 100%; height: 100%; object-fit: cover;background: url(https://jpjs.geeker.com.cn/frame/images/default_bg.png) no-repeat 50%; }
  .toolBtn-tit{ position: absolute; left: 0; bottom: 0; width: 100%; background-color: rgba(0,0,0,.5); height: 16px; line-height: 16px; color: #fff; font-size: 12px; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; overflow: hidden;}
  .toolBtn-tit > p{ display: inline-block; width: 95%; padding-right: 5%; }
  .toolBtn.curr{ border: 1px solid #faaf39; }
  .toolBtn.curr .toolBtn-tit{ color: #faaf39; }
  .toolBtn .video-see{position: absolute;right: -.34rem; top: .05rem; width: 1.1rem; height: .34rem; line-height: .34rem; font-size: .2rem;color:#fff;background-color: #f96900;text-align: center;transform: rotate(45deg);}
  /*.toolBtn.curr .toolBtn-tit > .p1 { -webkit-animation: move1 8s linear infinite; animation: move1 8s linear infinite; }*/
  /*.toolBtn.curr .toolBtn-tit > .p2 { -webkit-animation: move2 8s linear infinite; animation: move2 8s linear infinite; -webkit-animation-delay: 4s; animation-delay: 4s; }*/
  @-webkit-keyframes move1 {0% { -webkit-transform: translateX(100%); transform: translateX(100%) }to { -webkit-transform: translateX(-100%); transform: translateX(-100%) }}
  @keyframes move1 {0% { -webkit-transform: translateX(100%); transform: translateX(100%) }to { -webkit-transform: translateX(-100%); transform: translateX(-100%) }}
  @-webkit-keyframes move2 {0% { -webkit-transform: translateX(0); transform: translateX(0)  }to { -webkit-transform: translateX(-200%); transform: translateX(-200%) }}
  @keyframes move2 {0% { -webkit-transform: translateX(0); transform: translateX(0) }to { -webkit-transform: translateX(-200%); transform: translateX(-200%) }}

  #panoDesk div[name="SceneViewer"]{ z-index: auto!important;}

  #vrCont .info-scroll img,#vrCont .info-scroll .txt img{display: block;width: auto;max-width:100%;height: auto;margin: .24rem auto;text-indent: 0;}

  .PC .toolBar,.PC  .toolBox{ height: 100px;}

  .PC .toolBtn{width: 140px; height: 90px;}
</style>

<style scoped>
  @import '../../style/alert.css';

  .page{position: fixed; left: 0; top: 0; right: 0;bottom: 0; padding-bottom: 0; width: 100%; height: 100%; }
  /*地图*/
  .map-box{ position: relative; z-index: 1; width: 100vw; height: calc(100vh - 1.06rem);  }

  .load-tip{ padding-right: .25rem;}

  /*小图标*/
  .map-icons{ position: fixed; right: .25rem; top: .4rem; width: .73rem; z-index: 2; }
  .mygps{ margin-top: .25rem; margin-left: -.05rem; width: .85rem; max-width: .85rem!important; height: .84rem; }
  .map-icon{ padding: 0 .11rem; width: .51rem; background-color: #fff; box-shadow: 0 .03rem .05rem rgba(0,0,0,.2); border-radius: .08rem; }
  .map-icon > .border-box{ display: block; padding: .14rem 0 .1rem; width: .51rem; text-align: center; border-top: .01rem solid #e4e4e4; }
  .map-icon > .border-box:first-child{ border-top: none; }
  .map-icon > .border-box > img{ display: block; margin: 0 auto; width: .36rem; height: auto; }
  .map-icon > .border-box > p{ margin-top: .05rem; font-size: .2rem; color: #000; letter-spacing: .02rem; }

  /*讲解悬浮窗*/
  .flow{ position: relative;left: .27rem;top: .9rem; z-index: 2; width: 2.84rem; height: 1rem; padding:.09rem; box-shadow: 0 .05rem .08rem rgba(0,0,0,.1);background: #fff;border-radius: .1rem; }
  .flow-img{ position: relative; width: .82rem; height: .82rem; border-radius: 50%; overflow: hidden; }
  .flow-img .play{ position: absolute; left: 50%; top: 50%; z-index: 1; width: .34rem; height: .34rem; transform: translate(-50%,-50%); }

  /*导游+景点*/
  .spot{ position: fixed; left: 0; right: 0; bottom: 0; z-index: 3; background-color: #fff; box-shadow: 0 .05rem .09rem rgba(102,102,102,.1);  }
  .spot.slideUp{animation:mapSlideUp .6s linear;animation-fill-mode: forwards;  }
  @keyframes mapSlideUp {from{transform: translateY(100%); }to{transform: translateY(0);}}
  @keyframes mapSlideDown {from{transform: translateY(0); }to{transform: translateY(100%);}}
  @keyframes mapSlideDown1 {from{transform: translateY(0); }to{transform: translateY(5.57rem);}}
  .spot.slideDown{animation:mapSlideDown1 .6s linear;animation-fill-mode: forwards;  }

  .spot-nav{ position: relative; padding: 0 1rem 0 .2rem; border-bottom: .01rem solid #e3e3e3; }
  .spot-nav .spot-li{ padding: .15rem 0;height: .76rem; border-bottom: none; }
  .spot-nav .spot-li-img{width: .84rem; height: .76rem; border-radius: 0; }
  .spot-nav .spot-li-info{ height: .76rem; }
  .spot-nav .spot-li-info > h3{padding-top: .1rem; }
  .spot-nav-list{ display: inline-block; margin-right: .3rem; padding: 0 .2rem; }
  .spot-nav-list .icon{ display: block; margin: 0 auto; width: auto; height: .3rem; }
  .spot-nav-list .txt{ margin-top: .08rem; line-height: .22rem; font-size: .2rem; color: #a0a0a0; text-align: center; }
  .spot-nav-arr{ position: absolute; top: .15rem; right: 0; bottom: .15rem; width: 1rem; border-left: .02rem solid #e3e3e3;background: url(../../assets/sm-icon03-curr.png) no-repeat center; background-size: .32rem auto; }
  .spot.active .spot-nav-arr{ border-left: .01rem solid #e3e3e3; background: url(../../assets/sm-icon03.png) no-repeat center; background-size: .28rem auto; }

  .spot-cont{ height: 0; overflow: hidden; }
  .spot.active .spot-cont{ height: auto; }
  /*景点+厕所列表*/
  .navtab-scoll{ padding: 0 .07rem 0 .25rem; height: 5.2rem; overflow-x: hidden; overflow-y: auto; }
  .spot-li{ padding: .22rem 0; height: .84rem; border-bottom: .01rem solid #f5f5f5; }
  .spot-li-img{ position: relative; margin-right: .15rem; width: .84rem; height: .86rem; border-radius: 100%; overflow: hidden; }
  .spot-li-info{ position: relative; padding-right: 2.8rem; height: .86rem; }
  .spot-li-info > h3{ padding-top: .15rem; font: normal .28rem/.32rem "Microsoft YaHei"; color: #474747; }
  .spot-li-info.curr > h3{ color: #8cc816; }
  .spot-li-info > p{ margin-top: .1rem; font: normal .16rem/.2rem "Microsoft YaHei"; color: #a0a0a0; }
  .spot-li-info .but{ position: absolute; right: 0; top: 50%; transform: translateY(-50%); }
  .button{ display: inline-block; margin-right: .2rem; width: 1.06rem; height: .46rem; line-height: .48rem; font-size: .24rem; cursor: pointer; border: .01rem solid #666; color: #666;  text-align: center;  border-radius: .1rem; }

  /*导游列表*/
  .spot-guide{ box-shadow: 0 -.07rem .13rem rgba(231,231,231,.3); border-radius: .08rem .08rem 0 0; }
  .spot-tab{ padding: .2rem 0 .12rem; }
  .spot-tab p{ position: relative; height: .41rem; text-align: center; }
  .spot-tab p span{ display: inline-block; padding: 0 .04rem; height: .36rem; font: bold .26rem/.36rem "Microsoft YaHei"; color: #a4a3a3; border-bottom: .05rem solid transparent; }
  .spot-tab p.curr span{color: #040000; border-bottom: .05rem solid #f9ce17; }
  .spot-scoll{ padding: 0 .25rem; height: 4.77rem; overflow-x: hidden; overflow-y: auto; }
  .scoll-list{ height: auto; width: 100%; overflow-y: auto; overflow-x: hidden; }
  .list-li{ margin-top: .28rem; padding-bottom: .25rem; border-bottom: .01rem solid #f1f1f1; }
  .list-li-img{ position: relative; width: 1.48rem; height: 1.8rem; border-radius: .1rem; overflow: hidden; }
  .list-li-img .gif{ position: absolute; left: 0; right: 0; top: 0; bottom: 0; width: 100%; background-color: rgba(0,0,0,.5); }
  .list-li-img .gif img{ position: absolute; left: 50%; top: 50%; margin: -.11rem 0 0 -.105rem; width: .21rem; height: .22rem; }
  .list-li-info{ position: relative; margin-left: .3rem; height: 1.8rem; }
  .list-li-info .tit{ font-size: .32rem; color: #333; }
  .list-li-info .tit .tag{ vertical-align: text-top; }
  .list-li-info .tag{ display: inline-block; height: .3rem; line-height: .32rem; margin-left: .08rem; padding: 0 .1rem; color: #faaf39; border: .01rem solid #faaf39; font-size: .22rem; border-radius: .05rem;vertical-align: text-bottom; }
  .list-li-info .name{ margin-top: .1rem; line-height: .32rem; font-size: .24rem; color: #555; }
  .list-li-info .label{ position: relative; display: inline-block; height: .3rem; vertical-align: middle; line-height: .32rem; margin: .11rem .25rem 0 0; font-size: .2rem; color: #666; }
  .list-li-info .label img{ position: relative; left: 0; top: 50%; width: .24rem; height: .24rem; -webkit-transform: translateY(-50%); transform: translateY(-50%); }
  .list-li-info .bottom{ position: absolute; left: 0; bottom: 0; width: 100%; }
  .list-li-info .bottom .pri{ color: #faaf39; }
  .list-li-info .bottom .pri span{ font-size: .24rem; color: #666;}
  /*.list-li-info .bottom .btn{ right: .02rem; width: 1.2rem; }*/
  .list-li-info .bottom .button{ position: absolute; right: 0; bottom: -.05rem; width: 1.2rem; }

  /*当前播放语音*/
  .guide{ position: absolute; left: 0; top: -.9rem; z-index: 2; width: 0; height: .9rem; padding: .15rem .4rem .15rem 0; background: linear-gradient(to right ,rgba(255,168,32,.9),rgba(255,194,49,.9)); overflow: hidden; }
  .guide-icon{ position: absolute; right: 0; top: .15rem; width: .4rem; height: .6rem; background: url(../../assets/icon_45.png) no-repeat center; background-size: .3rem auto; }
  .guide.active{ width: 100%; padding-right: .8rem; }
  .guide.active .guide-icon{  width: .8rem; border-left: .01rem solid #fff; background: url(../../assets/icon_46.png) no-repeat center; background-size: .36rem auto; }
  .guide-box{  position: relative; width: 100%; height: .6rem; padding: 0 .2rem; }
  .guide-img{ position: relative; width: .6rem; height: .6rem; overflow: hidden; }
  .guide-voice{ position: relative; padding-left: .25rem; }
  .guide-tit{ font-size: .2rem; color: #fff; }
  .guide-btn{ margin-top: .06rem; }
  .guide-btn img{ display: inline-block; padding-right: .3rem; width: .26rem; height: auto; }
  .guide-btn .play{ padding-right: .35rem; margin-left: .23rem; margin-right: .25rem; }

  /*语音列表*/
  .voice-list{ padding: 0 .05rem; }
  .voice-list-p{ padding: .25rem 0 .25rem; height: .37rem; line-height: .37rem; font-size: .26rem; color: #5d5d5d; border-bottom: .01rem solid #f9f9f9; }
  .voice-list-p font{ font-size: .18rem; color: #e38c0f; }
  .voice-list-p.curr{ color: #ff7328; }
  .voice-list-p img{ display: inline-block; margin-right: .19rem; width: .28rem; height: auto; }
  .voice-list-p img.fl{ margin-right: .15rem; }

  /*VR列表*/
  .vr-list{position: relative; width: 100%; padding: .25rem 0; border-bottom: .01rem solid #f0f0f0;}
  .vr-list:last-child{border-bottom: none;}
  .vr-list-tit{position:relative;font-size:.28rem;color:#ffc53f;padding-left:.42rem;}
  .vr-list-tit img{position:absolute;left:0;top:50%;width:.26rem;height:.24rem;transform:translateY(-40%);}
  .vr-list-p{float:left;width: 31%;margin-right: 2.2%;margin-top: .2rem;}
  .vr-list-p:nth-of-type(3n){margin-right: 0;}
  .vr-list-p .p1{width: 100%;height: 1.5rem;overflow: hidden;}
  .vr-list-p .p2{margin-top: .08rem;width: 100%;height:.32rem;line-height:.32rem;font-size: .24rem;text-align: center;}
  .vr-list-p.curr .p1{border: 1px solid #faaf39;box-shadow: .02rem .02rem .08rem rgba(255,194,49,.9);}
  .vr-list-p.curr .p2{color: #ff7328;}


  /*视频弹窗*/
  .video-alert{position: fixed;z-index:999;left:0;top:0;width: 100vw;height: 100vh;background: rgba(0,0,0,1);}
  .video-close{position: absolute; z-index: 5; top: 10px; right: 20px; width: 15px; height: 15px; padding: 5px; background: #fff; border-radius: 50%;}
  .video-tip{position: absolute; z-index: 999; top: 10px; right: 0; width: 78px; height: 36px; line-height: 36px; padding-left: 15px; font-size: 15px; letter-spacing: 2px; color: #333; background: #fff; border-radius: 50px 0 0 50px; }
  .video-tip > img{ width: 30px; height: 30px; vertical-align: middle;  float: right; margin-top: 3px; margin-right: 5px; }
  .video-alert-mask{position:absolute;left:0;top:0;z-index: 2;width: 100%;}
  .video-alert-mask img{display: block;width: 63.6%;height: auto;margin: 18.5% auto 0;}
  .video-alert-btn{display: block;width: 1.62rem;height: .59rem;margin:1.7rem auto 0;text-align: center;font: bold .26rem/.59rem "Microsoft YaHei";color: #fff;border:1px dashed #fff;border-radius: .2rem;}
  .video-vricon{position: absolute; z-index: 999; bottom: 30vh; right: .3rem;width:1.14rem;height: 1.16rem;background: url(../../assets/icon_vr.png) no-repeat center;background-size: 100% 100%;}
  .video-vricon img{position: absolute; z-index: 1; top: -.25rem; right: -.1rem;width: .36rem;height: .36rem;}

  /*返回上一页按钮*/
  .link-btn{position: fixed;z-index:2;right:0;bottom:4rem;height: .6rem;padding:0 .28rem;font: .28rem/.6rem "Microsoft YaHei";color:#fff;border-radius: .3rem 0 0 .3rem;background: rgba(0,0,0,.7);}


  /*VR点位*/
  .vr-point{position: absolute; top: -500px; left: -500px;z-index:2; transform: scale(.5)}
  .vr-dot{ position: absolute; top: -.35rem; left: -.35rem; width: .7rem; height: .7rem; border-radius: 50%; background-size: 100%; box-shadow: 0 2px 4px rgba(0,0,0,.2); transition: all .3s ease 0s; transform-origin: center center}
  .vr-dot:after { content: ""; position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%) scale(1.3); width: 1.5rem; height: 1.5rem;
    -webkit-animation: audioShake-sprites-animation 1.375s steps(33) 0s infinite normal; animation: audioShake-sprites-animation 1.375s steps(33) 0s infinite normal }
  .vr-dot:before { content: ""; width: 2.5rem; height: 2.5rem; display: inline-block; position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%) }
  @-webkit-keyframes audioShake-sprites-animation {  0% {  background-position: 0 0  }  to {  background-position: -49.5rem 0  }  }
  @keyframes audioShake-sprites-animation { 0% {  background-position: 0 0  } to { background-position: -49.5rem 0  } }
  .vr-txt{position: absolute; top: -90px; left: -300px; width: 600px; font-size: 30px; text-align: center;font-weight: bold;}
  .vr-txt.colr1{color:#fff;}
  .vr-txt.colr2{color:#ffc303;}
  .vr-txt.colr3{color:#fff100;}
  .vr-dot.colr1{ background-color: #fff;}
  .vr-dot.colr2{ background-color: #ffc303;}
  .vr-dot.colr3{ background-color: #fff100;}
  .vr-dot.colr1:after{ background-image: url(../../assets/vr-dot1.png); background-size: 51rem 1.5rem;background-repeat: no-repeat;}
  .vr-dot.colr2:after{ background-image: url(../../assets/vr-dot.png); background-size: 51rem 1.5rem;background-repeat: no-repeat;}
  .vr-dot.colr3:after{background-image: url(../../assets/vr-dot3.png); background-size: 51rem 1.5rem;background-repeat: no-repeat;}

  .alert-info .alert-con {position: absolute;left: 50%;top: 46%;width: 80%;height: 66vh;background: #fff;border-radius: .2rem;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);color: #333;}
  .alert-info .tit{position:absolute;top:0;left:0;width:100%;height:.86rem;padding-top:.4rem;font: bold .32rem/.46rem "Microsoft YaHei";background: #fff;border-radius: .2rem .2rem 0 0;}
  .alert-info .info-scroll{position:absolute;top:.86rem;left: 0;width: 100%;height: calc(100% - .86rem);padding: .16rem .24rem .24rem;overflow-y: scroll;overflow-x: hidden;}
  .alert-info .txt{font: .28rem/.42rem "Microsoft YaHei";text-indent: .56rem;text-align: justify;}
  .alert-info .info-scroll img,.alert-info .info-scroll .txt img{display: block;width: auto;max-width:100%;height: auto;margin: .24rem auto;text-indent: 0;}
  .alert-info .close{position: absolute;top:-.74rem;left: 50%;width: .54rem;height: .54rem;margin-left: -.27rem;}

  /*.PC .navtab-scoll{height: 6.5rem;}*/
  /*.PC .vr-list-p{width: 16%;margin-right: .8%;margin-top: .25rem;}*/
  /*.PC .vr-list-p:nth-of-type(6n){margin-right: 0;}*/
  /*.PC .vr-list-p .p1{height: 2.5rem;}*/
  .PC .spot-li .but{display: none;}
  .PC .map-icons{display: none;}

  .PC .map-box{ position: relative; z-index: 1; margin-left: 34vw; width: calc(100vw - 34vw); height: 100vh;  }
  .PC .spot{ left: 0; top:0; right: inherit; bottom: 0; width: 34vw; }
  .PC .spot.active{ width: 34vw;}
  .PC .spot-cont{ height: 100%; overflow: hidden; }
  .PC .spot.active .spot-cont{ width: 100%; height: 100%; }

  .PC .spot-nav-arr{display: none;}
  .PC .spot-li-info{padding-right: 1rem;}
  .PC .navtab-scoll{height: calc(100vh - .91rem);}
  .PC .vr-list-p .p1{height: 2rem;}
  .PC .alert-info .alert-con{height: 78vh;}

</style>



// WEBPACK FOOTER //
// src/page/map/map-vr.vue